export default __webpack_public_path__ + "static/media/q21_02.7f648410.png";